import type { ReactNode } from "react";
import { Text } from "components/text";

export const BooksTableDetailRowDetailField = ({
  label,
  value,
  children,
}: {
  label: string;
  value?: string;
  children?: ReactNode;
}) => (
  <div className="flex flex-col gap-1.5 min-w-0">
    <Text as="span" variant="subtle" className="uppercase whitespace-nowrap">
      {label}
    </Text>
    {children ?? (
      <Text as="span" variant="detail" className="truncate" title={value}>
        {value}
      </Text>
    )}
  </div>
);
